import React, { useState, useCallback, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import styled, { ThemeProvider } from 'styled-components';
import {
  selectColor,
  sendTrackingInfo,
  Logo,
  ModalBase,
  Modal,
  TermsAndConditionsModal,
  ContactValidationModal,
  ReputationLevelModal,
  sendCustomTrackingInfo
} from '@panel/commons';
import { isPortalWithUnifiedPanel } from '@panel/commons/helpers/siteUtils';
import { getDevice, getContactModalPublisherType } from '@panel/commons/helpers';
import { getNeutralColors } from '@panel/commons/lib/theme';
import openHam from '@panel/commons/assets/icons/icon_ham_24x24_close.svg';
import closeHam from '@panel/commons/assets/icons/icon_ham_24x24_open.svg';
import { toggleFiltersModal } from '@panel/avisos/ducks/filter/actions';
import SnackBarContainer from '@panel/commons/lib/SimpleSnackbar/SnackBarContainer';
import NotificationButton from '@panel/commons/lib/Notifications/NotificationButton';
import { theme } from '@navent-re/global-styled';
import ModalProviderMonorepo from '@panel/commons/lib/Notifications/modal/src/modalContext';
import { userInfoOperations } from '../../../state/ducks/user';
import { HeaderMenu } from './headerMenu/HeaderMenu';
import { FiltersModal } from './FiltersModal/FiltersModal';
import ModalsContainer from './modals/ModalsContainer';
import MessageCounter from '../messageActivityCounter';
import { bumexFeatureSelectors } from '../../../state/ducks/bumexFeatures';
import { contactValidationSelectors, contactValidationOperations } from '../../../state/ducks/contactValidation';
import { reputationLevelSelectors, reputationLevelOperations } from '../../../state/ducks/reputationLevel';
import { bumexFeaturesKeys } from '../../../constants/bumexFeatures';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: ${props => (props.isBrasil ? '30px' : '0')};
  z-index: 9999;
  width: 100%;
  background-color: ${getNeutralColors('white')};
  border-bottom: 1px solid ${getNeutralColors('grisClaroII')};
`;

const LogoWrapper = styled.a`
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.6rem;
  :hover {
    cursor: pointer;
  }
`;
const MenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;
const Ham = styled.div`
  width: 48px;
  height: 60px;
  background: url(${props => (props.isOpen ? openHam : closeHam)}) no-repeat center center;
  :hover {
    cursor: pointer;
  }
`;

const FiltersModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: ${selectColor('white')};
`;

function HeaderMobile({
  updateAppliedFiltersAction,
  addSelectedFilterAction,
  // fetchUserInfoAction,
  resetPostingsAction,
  filtersOrder,
  user,
  isBrasil,
  toggleFiltersModalAction = () => {},
  filtersModalVisibility = false,
  selectedFilters = {},
  appliedFilters = {}
}) {
  const dispatch = useDispatch();
  const device = getDevice();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showModalTermsAndConditions, setShowModalTermsAndConditions] = useState(false);
  const [showModalContactValidation, setShowModalContactValidation] = useState(false);
  const [showModalReputationLevel, setShowModalReputationLevel] = useState(false);
  const [finishedAction, setFinishedAction] = useState({ action: '', result: '' });

  const {
    hasAcceptedTermsAndconditions,
    fetchedAcceptTermsAndConditions,
    errorAcceptTermsAndConditions,
    email,
    isLoading,
    publisherTypeId,
    isSeeker,
    hasConfirmedContactData,
    userLoggedId
  } = user;
  const userIsParticular = publisherTypeId === '1' || isSeeker;
  const contactPublisherTypeEnable = getContactModalPublisherType(publisherTypeId) && !isSeeker;

  const handleToggleMenu = () => {
    const isFolded = isOpen ? 'pliega' : 'despliega';
    sendTrackingInfo('Menu Hamburguesa', isFolded);
    setIsOpen(!isOpen);
  };

  const onMenuItemClick = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isOpen, setIsOpen]);

  const handleLogoClick = () => {
    sendTrackingInfo('Ir a Home');
    window.location = '/';
  };

  const path = process.env.REACT_APP_BUILD_SITE || 'ZPAR';

  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const { getContactValidationData } = useSelector(contactValidationSelectors.getContactValidationState);
  const { levelValue } = useSelector(reputationLevelSelectors.reputationLevelState);
  const reputationLevelState = useSelector(reputationLevelSelectors.reputationLevelState);
  const isPortalWithNewReputation = bumexFeatures.get(bumexFeaturesKeys.NEW_REPUTATION_SECTION);
  const actionFromNewPublisherCookie = Cookies.get('postingSavedInfoCrossPanel');
  const savedActionFromNewPublisherCookie = Cookies.get('postingSavedMessage');
  const isPortalWithContactModal = bumexFeatures.get(bumexFeaturesKeys.ENABLED_CONTACT_DATA_MODAL);
  const contactValidationCookie = Cookies.get('contactValidationSeen');
  const reputationLevelCookie = Cookies.get('reputationModalLevelSeen2');
  const handleOnClickTermsAndConditions = () => dispatch(userInfoOperations.acceptTermsAndConditions());

  const onCloseContactValidationModal = () => {
    Cookies.remove('contactValidationSeen');
    Cookies.set('contactValidationSeen', true, { expires: 1 });
    setShowModalContactValidation(false);
  };

  const onCloseReputationLevelModal = () => {
    Cookies.set('reputationModalLevelSeen2', true, { expires: 400 });
    setShowModalReputationLevel(false);
    sendCustomTrackingInfo({
      event: 'click_modal',
      content_group: 'Panel',
      user_reputation: levelValue,
      user_id: userLoggedId,
      item_id: 'Siguiente',
      modal_name: 'Modal presentacion Score'
    });
  };

  const isEnableTermsAndConditions =
    !isLoading &&
    // Se valida con el email que el usuario esté logueado:
    email &&
    // Se valida que el usuario no sea particular:
    !userIsParticular &&
    // Se valida desde userInfo que no se hayan aceptado Términos y Condiciones:
    !hasAcceptedTermsAndconditions &&
    // Se valida que no se haya enviado el dispatch para aceptar Términos y Condiciones:
    !fetchedAcceptTermsAndConditions &&
    // Se valida que el servicio no de error:
    !errorAcceptTermsAndConditions &&
    isPortalWithUnifiedPanel;

  const isEnableContactValidation =
    !isLoading &&
    // Se valida con el email que el usuario esté logueado:
    email &&
    contactPublisherTypeEnable &&
    isPortalWithContactModal &&
    // Se valida con el hasConfirmedContactData que el usuario no haya confirmado los datos:
    !hasConfirmedContactData;

  const isEnableReputationLevelModal =
    !isLoading &&
    // Se valida con el email que el usuario esté logueado:
    email &&
    // Se valida que el usuario no sea particular:
    !userIsParticular &&
    // Se valida el portal habilitado mediante la BF:
    isPortalWithNewReputation;

  useEffect(() => {
    // FETCH de datos para modal de Validación de contactos:
    if (isEnableContactValidation) dispatch(contactValidationOperations.getContactValidation());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnableContactValidation]);

  useEffect(() => {
    // Se valida que las condiciones estén dadas, que no exista la cookie y que ya se tengan los datos del Fetch (getContactValidationData.userPhones):
    if (isEnableContactValidation && getContactValidationData.userPhones && !contactValidationCookie) {
      setShowModalContactValidation(isEnableContactValidation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnableContactValidation, getContactValidationData.userPhones, contactValidationCookie]);

  useEffect(() => {
    if (isEnableTermsAndConditions) setShowModalTermsAndConditions(isEnableTermsAndConditions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnableTermsAndConditions]);

  useEffect(() => {
    // FETCH del nivel de reputación del usuario:
    if (isEnableReputationLevelModal) dispatch(reputationLevelOperations.getReputationLevel());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnableReputationLevelModal]);

  useEffect(() => {
    // Se valida que las condiciones estén dadas, que no exista la cookie y que ya se tengan el nivel de reputación del Fetch (reputationLevelSelectors.levelValue):
    const portalsExcluded = ['24MX', 'UBPE', 'CAPA', 'PLEC', 'ZPAR'].includes(path);
    if (isEnableReputationLevelModal && levelValue && !reputationLevelCookie && !portalsExcluded) {
      setShowModalReputationLevel(isEnableReputationLevelModal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnableReputationLevelModal, levelValue, reputationLevelCookie]);

  useEffect(() => {
    // Se lee una cookie (en vez de un parámetro por url) para evitar que se vuelva a disparar el snackbar al recargar la página.
    if (actionFromNewPublisherCookie && !savedActionFromNewPublisherCookie) {
      setFinishedAction({
        postingId: '',
        action: 'postingSaved',
        result: 'NEUTRAL',
        component: t(actionFromNewPublisherCookie)
      });
    }
    // Se elimina posteriormente la cookie:
    Cookies.remove('postingSavedInfoCrossPanel');

    // Saneamiento del state que dispara el Snackbar:
    return () => {
      setFinishedAction({ action: '', result: '' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionFromNewPublisherCookie, savedActionFromNewPublisherCookie]);

  return (
    <>
      <SnackBarContainer action={finishedAction} deviceType='mobile' />
      {isOpen || filtersModalVisibility
        ? document.body.classList.add('setHidden')
        : document.body.classList.remove('setHidden')}
      {filtersModalVisibility && (
        <FiltersModalWrapper>
          <FiltersModal
            selectedFilters={selectedFilters}
            appliedFilters={appliedFilters}
            filtersOrder={filtersOrder}
            onFiltersModalToggle={toggleFiltersModalAction}
            onSelectedFilterEdit={addSelectedFilterAction}
            onUpdateAppliedFilters={updateAppliedFiltersAction}
          />
        </FiltersModalWrapper>
      )}
      <HeaderWrapper id='headerMobile' data-panel='headerMobile' onClick={onMenuItemClick} isBrasil={isBrasil}>
        <ModalsContainer />
        <LogoWrapper data-panel='headerMobile_logo' onClick={handleLogoClick}>
          <Logo name={path} height='60' mobile />
        </LogoWrapper>
        <MenuWrapper>
          {bumexFeatures.get(bumexFeaturesKeys.FEEDBACK_NOTIFICATION) && (
            <ThemeProvider theme={theme}>
              <ModalProviderMonorepo>
                <NotificationButton siteId={path} isLogged breakpoint='mobile' isMobile />
              </ModalProviderMonorepo>
            </ThemeProvider>
          )}

          <Ham data-panel='headerMobile_ham' isOpen={isOpen} onClick={handleToggleMenu} id='headerMobile-menu'>
            {!isOpen && <MessageCounter />}
          </Ham>
        </MenuWrapper>
      </HeaderWrapper>
      <HeaderMenu
        isPortalWithNewReputation={isPortalWithNewReputation}
        reputationLevelState={reputationLevelState}
        isOpen={isOpen}
        onMenuItemClick={onMenuItemClick}
        user={user}
        isBrasil={isBrasil}
      />
      {showModalTermsAndConditions && (
        <Modal>
          <ModalBase openModal={showModalTermsAndConditions} width='352px' withoutCloseButton>
            <TermsAndConditionsModal
              onClose={() => setShowModalTermsAndConditions(false)}
              handleDispatch={handleOnClickTermsAndConditions}
            />
          </ModalBase>
        </Modal>
      )}
      {showModalContactValidation && (
        <Modal>
          <ModalBase
            openModal={showModalContactValidation}
            width={device === 'mobile' ? '352px' : '448px'}
            height={device === 'mobile' ? '95vh' : 'fit-content'}
            backgroundWrapper='white'
            overflow='scroll'
            withoutCloseButton
          >
            <ContactValidationModal
              onClose={onCloseContactValidationModal}
              setFinishedAction={setFinishedAction}
              publisherTypeId={publisherTypeId}
            />
          </ModalBase>
        </Modal>
      )}
      {showModalReputationLevel && (
        <Modal>
          <ModalBase
            openModal={showModalReputationLevel}
            onClose={() => {
              setShowModalReputationLevel(false);
              sendCustomTrackingInfo({
                event: 'click_modal',
                content_group: 'Panel',
                user_reputation: levelValue,
                user_id: userLoggedId,
                item_id: 'Salir',
                modal_name: 'Modal presentacion Score'
              });
            }}
            topPosition='16px'
            rightPosition='16px'
            withoutOutsideClose
            width={device === 'mobile' ? '100%' : '432px'}
            top='unset'
            borderRadius='8px 8px 0 0'
          >
            <ReputationLevelModal
              onClose={onCloseReputationLevelModal}
              userLoggedId={userLoggedId}
              pathname={pathname}
            />
          </ModalBase>
        </Modal>
      )}
    </>
  );
}

const mapDispatchToProps = {
  toggleFiltersModalAction: toggleFiltersModal
};

const mapStateToProps = ({ filters, user }) => ({
  selectedFilters: filters.selectedFilters,
  filtersModalVisibility: filters.filtersModalVisibility,
  user: user.info,
  filtersOrder: filters.filtersOrder
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMobile);
